import React, { JSX, useMemo } from "react";
import { Tooltip } from "react-tooltip";
import styled, { useTheme } from "styled-components";
import { v4 as uuid } from "uuid";
import { useIsMounted } from "@utils/hooks";

interface TooltipableProps {
	text: string;
	children: JSX.Element;
	offset?: number;
	dark?: boolean;
	customStyle?: {
		backgroundColor: string | null;
		textColor: string | null;
		backgroundColorIcon: string | null;
		textColorIcon: string | null;
	};
	position?: "left" | "right" | "top" | "bottom";
}
export const Tooltipable: React.FC<TooltipableProps> = ({
	children,
	text,
	offset,
	dark,
	customStyle,
	position = "bottom",
}) => {
	const tooltipId = useMemo(() => uuid(), []);
	const theme = useTheme();
	const mounted = useIsMounted();
	const backgroundColor =
		customStyle?.backgroundColor ||
		(dark ? theme.colors.black : theme.colors.secondary) ||
		customStyle?.backgroundColorIcon ||
		(dark ? theme.colors.black : theme.colors.white);
	const textColor =
		customStyle?.textColor ||
		(dark ? theme.colors.white : theme.colors.textPrimary) ||
		customStyle?.textColorIcon ||
		(dark ? theme.colors.textPrimary : theme.colors.secondary);
	const RenderedElement = mounted ? React.cloneElement(children, { "data-tooltip-id": tooltipId }) : children;

	const tooltipClassName = customStyle?.backgroundColor ? "custom-tooltip" : "";

	return (
		<>
			{RenderedElement}
			{mounted && (
				<StyledTooltip
					id={tooltipId}
					place={position}
					offset={offset}
					style={{ backgroundColor, color: textColor }}
					className={tooltipClassName}
				>
					<b>{text}</b>
				</StyledTooltip>
			)}
		</>
	);
};

const StyledTooltip = styled(Tooltip)`
	&.custom-tooltip {
		width: 250px;
	}
	white-space: normal;
`;
